<template>
    <div>
        <!-- {{ status }} 1 -->
        <v-card @click="openDialog" class="action-card" v-if='!data'>
            <v-img width="100px" max-height="50px" :src="slipOKImageUrl" />
        </v-card>
        <!--  -->
        <v-btn color="question" fab small dark  v-else @click="openDialog()">
            <v-icon> mdi-tools </v-icon>
        </v-btn>

        <!-- Dialog for SlipOK -->
        <v-dialog v-model="dialogSlipOK" persistent max-width="550px">
            <v-card>
                <!-- {{ data }} -->
                <v-form ref="form" v-model="validAdd" lazy-validation>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="8">
                                    <h3><strong>ตั้งค่าข้อมูล SlipOK</strong></h3>
                                </v-col>
                                <v-col cols="4" class="text-right">
                                    <v-btn fab small dark color="white" :style="styleCloseBt" @click="closeDialog">
                                        X
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="form.branchId_slipOK" label="BRANCH ID" outlined
                                        :rules="rules.branchId_slipOK"
                                        placeholder="https://api.slipok.com/api/line/apikey/YOUR_BRANCH_ID" />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="form.apiKey" label="API KEY" outlined
                                        :rules="rules.apiKey" />
                                </v-col>
                            </v-row>

                            <v-row class="align-center justify-center">
                                <v-col cols="10">
                                    <p class="mb-0">{{ form.switchSlipOK ? "เปิดใช้งาน" : "ปิดใช้งาน" }} SlipOK</p>
                                </v-col>
                                <v-col cols="2" class="text-right">
                                    <v-switch v-model="form.switchSlipOK"></v-switch>
                                </v-col>
                                <v-col>
                                    <v-btn block dark color="rgb(27, 67, 124)" @click="saveData(data)">บันทึก</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SlipOK',

  data () {
    return {
      dialogSlipOK: false,
      validAdd: true,
      slipOKImageUrl:
                'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2Fimages%20(1).png?alt=media&token=b7a76e81-92c4-4a90-9fb5-bdde2bffee56',
      form: {
        // https://api.slipok.com/api/line/apikey/23037
        // SLIPOKVJNRR8J
        branchId_slipOK: '',
        apiKey: '',
        switchSlipOK: true
      },
      rules: {
        branchId_slipOK: [
          // เช็คเว้นวรรค
          (v) => !!v || 'BRANCH ID is required',
          (v) => /^[^\u0E00-\u0E7F]*$/.test(v) || 'No Thai characters allowed',
          (v) => /^[^\s]+$/.test(v) || 'No spaces allowed',
          (v) => (typeof v === 'string' && v.startsWith('https://')) || 'Must start with "https://"'
        ],

        apiKey: [
          (v) => /^[^\s]+$/.test(v) || 'No spaces allowed',
          (v) => !!v || 'API KEY is required'
        ]
      },
      styleCloseButton: 'border-radius: 50%; color: red;'
    }
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    status: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {

    openDialog () {
      // ถ้ากดปุ่มแก้ไข จะส่ง param มา
      if (this.data) {
        this.form.branchId_slipOK = this.data.branchId_slipOK
        this.form.apiKey = this.data.apiKey
        this.form.payTypeId = this.data.payTypeId
        this.form.switchSlipOK = this.data.switchSlipOK === 'True'
      }

      if (!this.status) {
        this.dialogSlipOK = true
      } else {
        this.$swal('ไม่สำเร็จ', 'ตรวจพบรายการก่อนหน้านี้แล้ว', 'error')
      }
    },
    closeDialog () {
      this.dialogSlipOK = false
      this.resetForm()
      this.reset()
    },
    resetForm () {
      this.form.branchId_slipOK = ''
      this.form.apiKey = ''
      this.form.switchSlipOK = true
    },
    saveData () {
      if (this.$refs.form.validate()) {
        this.onChackQuotaSlipOK(this.form.branchId_slipOK, this.form.apiKey)
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    onChackQuotaSlipOK (branchIdSlipOK, apiKey) {
      const body = {
        branchId_slipOK: branchIdSlipOK + '/quota',
        apiKey: apiKey
      }
      try {
        axios.post(this.$DNS_IP + '/check_SlipOK', body).then(res => {
          if (res.data.success) {
            // เช็คผ่าน ให้ทำต่อ
            if (!this.form.payTypeId) {
              this.form.payTypeCode = this.code + this.generateCodeGlobal()
              this.form.payTypeName = 'SlipOK'
              this.form.CREATE_USER = this.$session.getAll().data.userName
              this.form.LAST_USER = this.$session.getAll().data.userName
              this.form.shopId = this.$session.getAll().data.shopId
              this.form.payType = 'SlipOK'
            }

            this.form.branchId_slipOK = this.form.branchId_slipOK.replaceAll(' ', '')
            this.form.apiKey = this.form.apiKey.replaceAll(' ', '')
            this.submit()
          } else {
            // เช็คไม่ผ่าน ให้แจ้งเตือน
            let errorMsg = ''
            if (res.data.code === 1001) {
              errorMsg = 'BRANCH ID ไม่ถูกต้อง'
            } else if (res.data.code === 1002) {
              errorMsg = 'API KEY ไม่ถูกต้อง'
            } else if (res.data.code === 1003) {
              errorMsg = 'Package ของคุณหมดอายุแล้ว'
            }
            this.$swal('ไม่สำเร็จ', errorMsg, 'error')
          }
        })
      } catch (error) {
        console.log('error => ', error)
      }
    },
    submit () {
      try {
        this.$swal({
          title: !this.form.payTypeId || this.form.payTypeId === ''
            ? 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?'
            : 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',

          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(result => {
            if (!this.form.payTypeId || this.form.payTypeId === '') {
              try {
                // add
                axios.post(this.$DNS_IP + '/master_payment/add', this.form).then(res => {
                  this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                  this.closeDialog()
                  this.$emit('selectBranch')
                })
              } catch (error) {
                console.log('error', error)
                this.$swal('ไม่สำเร็จ', 'ลองใหม่อีกครั้ง', 'success')
              }
            } else {
              // update
              try {
                axios.post(this.$DNS_IP + '/master_payment/edit/' + this.form.payTypeId, this.form).then(res => {
                  this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                  this.closeDialog()
                  this.$emit('selectBranch')
                })
              } catch (error) {
                console.log('error', error)
                this.$swal('ไม่สำเร็จ', 'ลองใหม่อีกครั้ง', 'success')
              }
            }
          })
      } catch (error) {
        console.log('error => ', error)
      }
    }
  }
}
</script>

<style scoped>
.action-card {
    border-radius: 5px;
    border: solid #1d00ff4a;
    margin-right: 5px;
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Extensions/SlipOk.vue